var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main container-fluid"},[_c('integrations-state-user-settings',{attrs:{"auto_connect":_vm.auto_connect,"service":_vm.service,"error_code":_vm.error_code,"scroll_to":_vm.scroll_to,"success":_vm.success}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }